import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import '@/plugins/bootstrap-vue.plugin'
import '@/plugins/fontawesome.plugin'
import '@/plugins/vuelidate.plugin'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import appConfig from '@/config/app.config'
import * as filters from '@/config/filters'
import AccessibilityPlugin from '@/plugins/accessibility.plugin'
import * as VueGoogleMaps from 'vue2-google-maps'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import VueI18n from 'vue-i18n'
import enTranslations from '@/locales/en.js'
import frTranslations from '@/locales/fr.js'

Vue.config.productionTip = false
Vue.use(AccessibilityPlugin);
Vue.use(Autocomplete)
Vue.use(VueI18n)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCBX7qtsIrJ4M9zeRvMaJCOTGo9L1oCpr8',
    libraries: 'places,drawing,geometry',
    version: '3.64',
    v: '3.64'
  },
})
/**
 * Inject Config in Vue Instance
 */
Vue.prototype.$config = appConfig

/**
 * Event Bus for Global Event Hanlding
 */


const eventbus = new Vue()
Vue.prototype.$eventbus = eventbus

/**
 * Add Filters to Vue Instance
 */
for (const key in filters) {
  Vue.filter(key, filters[key]);
}

Vue.filter('round', function (value, roundVal=2) {
  if (!value) return ''
  return value.toFixed(roundVal)
})
/**
 * Initialize Vue 
 */
const messages = {
  en: enTranslations,
  fr: frTranslations
}

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
